<div class="em-c-table-object">
  <div class="em-c-table-object__header"></div>
  <div class="em-c-table-object__body">
    <div class="em-c-table-object__body-inner" style="overflow: visible">
      <table class="em-c-table">
        <!-- Table header -->
        <thead class="em-c-table__header">
          <tr class="em-c-table__header-row">
            <th
              scope="col"
              class="em-c-table__header-cell exception-table__col"
            >
              Exception
            </th>
            <th
              scope="col"
              class="em-c-table__header-cell exception-table__col"
            >
              Exception Value
            </th>
            <th
              scope="col"
              class="em-c-table__header-cell exception-table__actioncol"
              *ngIf="!isViewOnly"
            >
              Action
            </th>
          </tr>
        </thead>
        <!-- Exception Row -->
        <tbody class="em-c-table__body">
          <exception-table-row
            [exception]="exception"
            [isViewOnly]="isViewOnly"
            [allExceptions]="exceptions"
            (updateException)="handleUpdateException($event)"
            (deleteException)="handleDeleteException($event)"
            *ngFor="let exception of exceptions | isDeletedException: false"
            (selectedValueChange)="handleSelectedValueChange(exception.id)"
            [error]="error == null ? '' : error[exception.id]"
          >
          </exception-table-row>
        </tbody>
      </table>
    </div>
  </div>
  <div class="em-c-table-object__footer table-footer">
    <div class="em-c-btn-group" *ngIf="!isViewOnly">
      <button class="em-c-btn" (click)="onCancel()">
        <span class="em-c-btn__text">Cancel</span>
      </button>
      <button class="em-c-btn em-c-btn--primary" (click)="onSave()">
        <span class="em-c-btn__text">Save</span>
      </button>
    </div>
    <div
      class="em-c-btn-group"
      *ngIf="
        isViewOnly && (storeService.user$ | async)?.canMaintainSupplierProfile
      "
    >
      <button class="em-c-btn" (click)="toggleEditMode()">
        <span class="em-c-btn__text">Edit</span>
      </button>
    </div>
  </div>
</div>
